import Init from './Initer';
import TH_OverlayScrollbars from '_tradeholding/js/Classes/OverlayScrollbars';

Init.addRegister('overlayscrollbars', TH_OverlayScrollbars.initMultiple, TH_OverlayScrollbars);